/**
 * React browser entry point
 * PURPOSE: Mounts the application, translation provider and router.
 *
 * EDITING GUIDE:
 * - Read the comments above each section or function before changing behavior.
 * - Keep validation, authentication and error handling in place for production safety.
 * - Search for "EDIT HERE" to find the most common business-content settings.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
